import { z } from "zod"
import { Network, Token } from "@/config/tokens"
import { PaymentLinkType } from "@/api/payment-links"

const amountValidation = (value: string | undefined) =>
  value === undefined || value === "" || /^[0-9]+(\.[0-9]{1,6})?$/.test(value)

export const paymentLinkSchema = z
  .object({
    type: z.nativeEnum(PaymentLinkType, { required_error: "Type is required" }),
    title: z.string().min(5, "Title must be at least 5 characters long"),
    description: z.string(),
    networks: z.array(z.nativeEnum(Network)).min(1),
    token: z.nativeEnum(Token),
    amount: z
      .string()
      .optional()
      .refine(amountValidation, {
        message: "Amount must be a valid value with up to 6 decimal places",
        path: ["amount"],
      })
      .transform((v) => (v !== undefined ? parseFloat(v) : undefined)),
    minAmount: z
      .string()
      .optional()
      .refine(amountValidation, {
        message: "Min Amount must be a valid value with up to 6 decimal places",
        path: ["minAmount"],
      })
      .transform((v) => (v !== undefined ? parseFloat(v) : undefined)),
    maxAmount: z
      .string()
      .optional()
      .refine(amountValidation, {
        message: "Max Amount must be a valid value with up to 6 decimal places",
        path: ["maxAmount"],
      })
      .transform((v) => (v !== undefined ? parseFloat(v) : undefined)),
    active: z.boolean(),
    presetAmounts: z
      .array(z.string().optional())
      .optional()
      .transform((v) =>
        v
          ?.filter((v) => v !== "" && v !== undefined)
          .map((v) => parseFloat(v!)),
      ),
  })
  .refine(
    (data) => {
      if (
        data.type === PaymentLinkType.FIXED_AMOUNT &&
        data.amount === undefined
      ) {
        return false
      }
      return true
    },
    {
      message: "Amount is required",
      path: ["amount"],
    },
  )
